import type { FaireThemeEntity } from "../../entity_types/theme";

export const moissanite_and_sterling_luxury: FaireThemeEntity = {
  token: "moissanite-and-sterling-luxury",
  type: "theme",
  name: "Moissanite & Sterling Luxury",
  description: "Offer your clients the brilliance of premium gemstones with moissanite and solid silver rings. These high-quality alternatives to traditional diamonds provide an elevated touch to your jewelry display.",
  teaser: "As a Beauty Lounge in San Jose, your customers likely appreciate high-end aesthetics and self-care. Carrying premium jewelry like moissanite aligns with a luxury beauty experience.",
  detail: "The additional_context shows a Moissanite Star Wedding Band from Perimade & Co. in your cart, indicating a specific interest in high-quality, ethically sourced fine jewelry.",
  bgColor: "#F0D4C4",
  tileBgColor: "#4a4a6b",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_8azzac2ram",
    "p_jbhncvnhwy",
    "p_4xcesem9dr",
    "p_yv5uv926s9",
    "p_hhck9gk33d",
    "p_322uz8qbeh",
    "p_qyenz7qrvm",
    "p_2h9aqyn68v",
    "p_n79cdq8nh4",
    "p_ga9qg8b625",
    "p_qvk64uadtg",
    "p_xe9n25w5cc",
    "p_w5jyrw3xnf",
    "p_e3fb5ec9r5",
    "p_mnc2gjxtxm",
    "p_xrdpdgf7ux",
    "p_mzrmu6xbsd",
    "p_v6zxyeew52",
    "p_4khkrs22jc",
    "p_xzwgnz6z67",
    "p_2zy6jtwwkt",
    "p_nwg9g6uj2t",
    "p_mdmsajeuha",
    "p_ftg7kbzfqx",
    "p_8ecfjessqr",
    "p_c2948cbf8r",
    "p_ek47rqcx2d",
    "p_anhrm56q5g",
    "p_bdxjz48pcf",
    "p_cmfk2t3qjv",
    "p_gcns9zt79c",
    "p_rmqhxjnj9c",
    "p_umjf55b5pm",
    "p_e69ewgrnz7",
    "p_4f28b87jzr",
    "p_cwtrvfdha6",
    "p_tum68mm6qu",
    "p_j9rp2tp74j",
    "p_9h9fzwygjn",
    "p_rwqfqcxuxz",
    "p_hcnfc8e9wc",
    "p_d5x2aerrdh",
    "p_h2ww6ungg7",
    "p_bffjnnw2gz",
    "p_vbgpbc5hkp",
    "p_n5c6azucu8",
    "p_ykmjtqcawm",
    "p_67uhkkdyv8",
    "p_c9f9q5putg",
    "p_nz7euf94ma",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
